module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-large.596d171e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-large.png
// module id = 3112
// module chunks = 11